class KeyboardNavigation {
    constructor({$rootLinks, closestSelectorToPreventToHideMenu, rootLinkContainerSelector}) {
        this._$rootLinks = $rootLinks;
        this._closestSelectorToPreventToHideMenu = closestSelectorToPreventToHideMenu;
        this._rootLinkContainerSelector = rootLinkContainerSelector;
    }

    init() {
        const self = this;

        jQuery('a, button, select, input, [tabindex="0"]').on('focus', function () {
            const $el = $(this);

            if (!$el.closest(self._closestSelectorToPreventToHideMenu).length) {
                self._removeAllActiveClasses();
            }
        });

        self._$rootLinks.on('focus', function (e) {
            const $navLink = $(this);

            self._addClassActive($navLink);
        });

        $(document).on('click', function (e) {
            const $el = jQuery(e.target);

            if (!$el.hasClass('unfocusable-click')) {
                self._removeAllActiveClasses();
            }
        });
    }

    _addClassActive($navLink) {
        if (!$navLink || !$navLink.length) {
            return;
        }

        const $navLinkContainer = this._rootLinkContainerSelector !== null
            ? $navLink.closest(this._rootLinkContainerSelector)
            : $navLink;

        $navLinkContainer.addClass('active');
    }

    _removeClassActive($navLink) {
        if (!$navLink || !$navLink.length) {
            return;
        }

        const $navLinkContainer = this._rootLinkContainerSelector !== null
            ? $navLink.closest(this._rootLinkContainerSelector)
            : $navLink;

        $navLinkContainer.removeClass('active');
    }

    _removeAllActiveClasses() {
        this._$rootLinks.each((i, navLink) => {
            const $navLink = $(navLink);

            this._removeClassActive($navLink);
        });
    }
}

$(function () {
    const $navLinks = jQuery('ul.navbar-nav > li.nav-item > .nav-link');

    if ($navLinks.length) {
        (new KeyboardNavigation({
            $rootLinks: $navLinks,
            closestSelectorToPreventToHideMenu: '.sub-menu',
            rootLinkContainerSelector: 'li.nav-item',
        })).init();
    }

    const $zodiacSelectors = jQuery('#your-sign, #partner-sign');

    if ($zodiacSelectors.length) {
        (new KeyboardNavigation({
            $rootLinks: $zodiacSelectors,
            closestSelectorToPreventToHideMenu: '.select-items',
            rootLinkContainerSelector: null,
        })).init();
    }
});
